import { AUDIT_LOG_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { formatDateToYYYYMMDDLocal } from "../../shared/utils/functions";
import { AuditLogFilters } from "./types";

// empty values are sent as null so the backend skips that filter
export const toAuditLogQueryParams = (filters: AuditLogFilters) => ({
  entityType: filters.entityType,
  entityId: filters.entityId || null,
  companyId: filters.companyId || null,
  action: filters.action,
  actorType: filters.actorType,
  actorEmail: filters.actorEmail || null,
  fromDate: filters.fromDate ? formatDateToYYYYMMDDLocal(filters.fromDate) : null,
  toDate: filters.toDate ? formatDateToYYYYMMDDLocal(filters.toDate) : null,
});

export const AuditLogService = {
  getAll: (params: any) => requests.get(`${AUDIT_LOG_URL}`, params),
};
